import React from "react";
import { render as generatePlainText } from "datocms-structured-text-to-plain-text";

import { Button } from "../../Button";
import { StructuredTextRenderer } from "../../StructuredTextRenderer";

import t from "../../../lib/translate";
import { generateClassString } from "../../../lib/helper/generateClassString";
import remoteAssetUrl from "../../../lib/remote-asset-url";
import isInternalLink from "../../../lib/helper/isInternalLink";

import * as styles from "./TeaserButton.module.less";

export function TeaserButton({
    structuredText: linkData,
    document,
    url,
    label,
    hideLabel = false,
    type = "primary",
    ...props
}) {
    if (!linkData && !url && !document) {
        return null;
    }

    const title = linkData?.value
        ? generatePlainText(linkData)
        : label || "NO LABEL";

    return (
        <div
            className={generateClassString(styles.teaserButton, [
                hideLabel,
                styles.hideLabel
            ])}
        >
            {linkData?.value && (
                <>
                    {!!url ? (
                        <Button
                            renderAs={"link"}
                            type={type}
                            to={url}
                            icon={
                                isInternalLink(url)
                                    ? "arrowRight"
                                    : "arrowUpRight"
                            }
                            iconPosition={"right"}
                            aria-label={
                                title
                                    ? title
                                    : t('teaser.link.default-label')}
                            title={title}
                            {...(isInternalLink(url)
                                ? {}
                                : { target: "_blank" })}
                            {...props}
                        >
                            {title}
                        </Button>
                    ) : (
                        <StructuredTextRenderer
                            data={linkData}
                            plainLink
                            noContainer
                            itemLinkType={type}
                            contentElementType={"TeaserButton"}
                        />
                    )}
                </>
            )}

            {!linkData?.value && url && (
                <Button
                    renderAs={"link"}
                    type={type}
                    to={url}
                    icon={isInternalLink(url) ? "arrowRight" : "arrowUpRight"}
                    iconPosition={"right"}
                    aria-label={label || "NO LABEL"}
                    {...(isInternalLink(url) ? {} : { target: "_blank" })}
                    {...props}
                >
                    {label || "NO LABEL"}
                </Button>
            )}

            {/* Hint: A document is not a download and won't link to the download form. EVER!!!!!11!ELF */}
            {/* teaserDocument is used in Publication Teaser */}
            {document && (
                <Button
                    renderAs={"link"}
                    type={"primary"}
                    icon={"download"}
                    iconPosition={"right"}
                    to={remoteAssetUrl(document.url)}
                    target="_blank"
                    aria-label={document.title}
                    title={document.title}
                >
                    {document.filename}
                </Button>
            )}
        </div>
    );
}
